import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import sanitizeInnerHtml from 'nucleus-text/sanitize/sanitizeInnerHtml';

/**
* The basic description widget UI implementation.
*/
export default class Description extends React.Component {
  static displayName = 'Description';
  static propTypes = {
    text: PropTypes.string,
    shouldRenderHtml: PropTypes.bool
  };
  static defaultProps = {
    shouldRenderHtml: true
  };
  render() {
    const { text, shouldRenderHtml } = this.props;
    return (
      <div {...resolveTestId(this.props)} {...resolve(this.props, 'container')}>
        <div {...resolve(this.props, 'text')}>
          { shouldRenderHtml ?
            <div dangerouslySetInnerHTML={sanitizeInnerHtml(text)} /> :
            <p>{text}</p>
          }
        </div>
      </div>
    );
  }
}
